<div class="dialog-content-wrapper">

    <mat-toolbar matDialogTitle class="accent-600 m-0 dialog-toolbar">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <div class="contact-name mt-8">Informações Gerais</div>
            <button mat-icon-button (click)="dimiss()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div class="mt-15" *ngIf="loading" fxLayoutAlign="center center">
        <mat-spinner></mat-spinner>
    </div>

    <div mat-dialog-content class="dialog-content p-12 pb-0 m-0" *ngIf="!loading">

        <!-- FORM FIXO -->
        <form name="generalInformationForm" [formGroup]="generalInformationForm"
            class="generalInformation-edit w-100-p form-fixed" fxLayout="column" fxLayoutGap="12px">

            <mat-form-field appearance="outline">
                <mat-label>Selecione</mat-label>
                <mat-select [formControl]="typeControl" disableRipple>
                    <mat-option value="1">Convênio</mat-option>
                    <mat-option value="2">Profissionais</mat-option>
                    <mat-option value="3">Gerenciar e-mail</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="typeControl.value == '1'" appearance="outline">
                <mat-label>Convênio</mat-label>
                <input matInput [matAutocomplete]="autoInsurance" formControlName="insurance" autocomplete="off"
                    type="search" />

                <mat-autocomplete #autoInsurance="matAutocomplete" [displayWith]="displayInsuranceFn">
                    <mat-option *ngFor="let insurance of insuranceList" [value]="insurance">
                        {{ insurance.name }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field *ngIf="typeControl.value == '2'" appearance="outline">
                <mat-label>Profissional</mat-label>
                <input matInput [matAutocomplete]="autoProfessional" formControlName="professional" type="search">

                <mat-autocomplete #autoProfessional="matAutocomplete" [displayWith]="displayPerformerFn">
                    <mat-option *ngFor="let professional of professionalList" [value]="professional">
                        {{ professional.person.name }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

        </form>

        <!-- TABS COM SCROLL -->
        <div *ngIf="typeControl.value == '3'" class="email-manager-content">

            <div class="email-toolbar" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="12px"
                fxLayoutAlign="space-between center">

                <mat-form-field appearance="outline" class="email-search-field">
                    <mat-label>Buscar destinatário</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput [formControl]="emailSearchForm" type="search" autocomplete="off">
                </mat-form-field>

                <mat-form-field appearance="outline" class="email-status-field">
                    <mat-label>Status</mat-label>
                    <mat-select [formControl]="emailStatusControl" disableRipple>
                        <mat-option *ngFor="let status of emailStatusOptions" [value]="status.value">
                            {{ status.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <button mat-icon-button class="email-refresh-button" matTooltip="Atualizar listagem"
                    (click)="getEmailList()">
                    <mat-icon>refresh</mat-icon>
                </button>
            </div>


            <!--
             <div class="email-status-legend" fxLayout="row wrap" fxLayoutGap="8px">
                <div class="email-status-chip" *ngFor="let status of emailStatusOptions" [hidden]="!status.value"
                    [ngClass]="'email-status-' + status.value"
                    [matTooltip]="getEmailStatusTooltip(status.value)"
                    [attr.title]="getEmailStatusTooltip(status.value)">
                    <mat-icon>{{ getEmailStatusIcon(status.value) }}</mat-icon>
                    <span>{{ status.label }}</span>
                </div>
            </div>
            -->


            <div class="email-list-header" fxLayout="row" fxLayoutAlign="start center">
                <div fxFlex="28">Destinatário</div>
                <div fxFlex="28">Assunto</div>
                <div fxFlex="16">Status</div>
                <div fxFlex="14">Solicitado</div>
                <div fxFlex="14">Último evento</div>
            </div>

            <div class="email-list-scroll">

                <div class="email-loading" *ngIf="emailLoading" fxLayoutAlign="center center">
                    <mat-spinner diameter="36"></mat-spinner>
                </div>

                <div class="email-row" *ngFor="let email of emailList" fxLayout="row" fxLayoutAlign="start center"
                    [ngClass]="{ 'email-row-error': isEmailFailure(email.status) }">

                    <div fxFlex="28" class="email-cell email-recipient">
                        <div class="text-ellipsis">{{ email.recipientEmail || '-' }}</div>

                    </div>

                    <div fxFlex="28" class="email-cell">
                        <div class="text-ellipsis" [matTooltip]="email.subject">{{ email.subject || '-' }}</div>
                        <small class="text-ellipsis" *ngIf="email.statusReason" [matTooltip]="email.statusReason">
                            {{ email.statusReason }}
                        </small>
                    </div>

                    <div fxFlex="16" class="email-cell">
                        <div class="email-status-pill" [ngClass]="'email-status-' + email.status"
                            [matTooltip]="getEmailStatusTooltip(email.status)"
                            [attr.title]="getEmailStatusTooltip(email.status)">
                            <mat-icon>{{ getEmailStatusIcon(email.status) }}</mat-icon>
                            <span>{{ getEmailStatusLabel(email.status) }}</span>
                        </div>
                    </div>

                    <div fxFlex="14" class="email-cell email-date">
                        {{ email.requestedAt | date:'dd/MM/yyyy HH:mm' }}
                    </div>

                    <div fxFlex="14" class="email-cell email-date">
                        {{ email.lastEventAt ? (email.lastEventAt | date:'dd/MM/yyyy HH:mm') : '-' }}
                    </div>

                </div>

                <div class="empty-list" *ngIf="!emailLoading && (!emailList || emailList.length === 0)">
                    Nenhum e-mail encontrado.
                </div>

            </div>

            <mat-paginator class="email-paginator" showFirstLastButtons [length]="emailTotalElements"
                [pageIndex]="emailPagina" [pageSize]="emailTamanho || emailPageOptions.sizePage"
                [pageSizeOptions]="[10, 25, 50]" (page)="getEmailList($event,'page')">
            </mat-paginator>

        </div>

        <mat-tab-group *ngIf="typeControl.value != '3'" class="tab-size tab-scroll-wrapper" [disableRipple]="true"
            mat-stretch-tabs>

            <!-- AVISO -->
            <mat-tab label="Aviso">
                <div class="tab-scroll-content">

                    <mat-tab-group class="tab-size" [disableRipple]="true" mat-stretch-tabs
                        [selectedIndex]="selectedTabIndex" (selectedIndexChange)="changeViewByTab($event)">

                        <mat-tab *ngFor="let alert of alertList; let index = index" [label]="alert.name">
                            <quill-editor style="height: 300px" [modules]="configEditor" [formControl]="alertForm"
                                [disabled]="true" format="html">
                            </quill-editor>
                        </mat-tab>

                    </mat-tab-group>

                </div>
            </mat-tab>

            <!-- PLANOS -->
            <mat-tab *ngIf="typeControl.value == '1'" label="Planos">
                <div class="tab-scroll-content">

                    <mat-list style="border: 1px solid; border-radius: 5px; padding: 5px; margin: 5px;"
                        *ngFor="let plan of planList">

                        <mat-list-item>{{ plan.name }}</mat-list-item>

                    </mat-list>

                </div>
            </mat-tab>

            <!-- TABELA DE PREÇO -->
            <mat-tab *ngIf="typeControl.value == '1'" label="Tabela de Preço">
                <div class="price-tab-content">

                    <mat-form-field appearance="outline" class="procedure-search-field">
                        <mat-label>Buscar Procedimento</mat-label>
                        <input matInput [formControl]="procedureForm" type="search">
                    </mat-form-field>

                    <!-- HEADER FIXO -->
                    <div class="accreditation-list-header" fxLayout="row" fxLayoutAlign="start center">
                        <div fxFlex="50">Procedimento</div>
                        <div fxFlex="30">Empresa</div>
                        <div fxFlex="20" class="text-right">Valor</div>
                    </div>

                    <!-- SOMENTE A LISTA ROLA -->
                    <div class="price-list-scroll">

                        <mat-accordion *ngIf="accreditationProcedureList?.length > 0">
                            <mat-expansion-panel *ngFor="let item of accreditationProcedureList">

                                <mat-expansion-panel-header>
                                    <mat-panel-title class="panel-header-content">
                                        <div fxLayout="row" fxLayoutAlign="start center" fxFlex>
                                            <div fxFlex="50" class="text-ellipsis"
                                                [innerHTML]="highlightText(item.procedureName)">
                                            </div>

                                            <div fxFlex="30" class="text-ellipsis">
                                                {{ item.companyName || '-' }}
                                            </div>

                                            <div fxFlex="20" class="text-right">
                                                {{ item.value | currency:'BRL' }}
                                            </div>
                                        </div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>

                                <div fxLayout="column" fxLayoutGap="8px" class="panel-body">
                                    <div><strong>Código:</strong> {{ item.code || '-' }}</div>
                                    <div><strong>Código reduzido:</strong> {{ item.reduceCode || '-' }}</div>
                                    <div><strong>Convênio:</strong> {{ item.insuranceName || '-' }}</div>
                                    <div><strong>Empresa:</strong> {{ item.companyName || '-' }}</div>
                                    <div><strong>Validade:</strong> {{ item.validity | date:'dd/MM/yyyy' }}</div>
                                    <div><strong>Valor:</strong> {{ item.value | currency:'BRL' }}</div>

                                    <div>
                                        <strong>Status:</strong>
                                        <span [ngClass]="item.active ? 'status-active' : 'status-inactive'">
                                            {{ item.active ? 'Ativo' : 'Inativo' }}
                                        </span>
                                    </div>
                                </div>

                            </mat-expansion-panel>
                        </mat-accordion>

                        <div class="empty-list"
                            *ngIf="!accreditationProcedureList || accreditationProcedureList.length === 0">
                            Nenhum procedimento encontrado.
                        </div>

                    </div>

                    <mat-paginator class="price-paginator" #paginator showFirstLastButtons [length]="totalElements"
                        [pageIndex]="pagina" [pageSizeOptions]="[5]"
                        (page)="getAccreditationProcedureList($event,'page')">
                    </mat-paginator>

                </div>
            </mat-tab>

        </mat-tab-group>

    </div>
</div>